import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2 } from "lucide-react";

interface AddDeleteListProps {
    currQuantity: number;
    /** Called when the user taps the + button. */
    onIncrement: () => void;
    /** Called when the user taps the − button (or trash when qty === 1). */
    onDecrement: () => void;
}

export const AddDeleteList: React.FC<AddDeleteListProps> = ({ currQuantity, onIncrement, onDecrement }) => {
    return (
        <div className="flex justify-evenly gap-1 items-center">
            <Button variant="ghost" size="icon" onClick={onDecrement}>
                {currQuantity <= 1
                    ? <Trash2 className="size-4 text-destructive" />
                    : <Minus className="size-4 text-primary" />}
            </Button>
            <span className="text-xs min-w-3 mx-auto text-center">{currQuantity}</span>
            <Button variant="ghost" size="icon" onClick={onIncrement}>
                <Plus className="size-4 text-primary" />
            </Button>
        </div>
    );
}
